// API Endpoints
export const API_ENDPOINTS = {
  CREATE_CHECKOUT: '/api/create-checkout-session',
  SESSION_STATUS: '/session-status',
  DOWNLOAD_ALL: '/api/download-all',
  SEND_EMAIL: '/api/send-email'
};

// Error Messages
export const ERROR_MESSAGES = {
  DOWNLOAD_FAILED: 'Failed to download files. Please try again.',
  VERIFICATION_ERROR: 'We encountered an issue verifying your purchase. Please contact me for support.',
  RESEND_FAILED: 'Failed to resend email. Please try again or contact support.',
  ITEM_NOT_FOUND: 'Sorry, we couldn\'t find the requested item.',
  CHECKOUT_ERROR: 'Error creating checkout session'
};

// Analytics Events
export const ANALYTICS_EVENTS = {
  DOWNLOAD_ALL_ATTEMPT: 'download_all_attempt',
  DOWNLOAD_ALL_SUCCESS: 'download_all_success',
  DOWNLOAD_ALL_ERROR: 'download_all_error',
  RESEND_EMAIL_ATTEMPT: 'resend_email_attempt',
  RESEND_EMAIL_SUCCESS: 'resend_email_success',
  RESEND_EMAIL_ERROR: 'resend_email_error',
  AUDIO_PLAY: 'audio_play'
};

// Development fallback data
export const DEV_FALLBACK = {
  EMAIL: 'dev-mode@example.com',
  PRODUCT: {
    id: 'sample-product',
    title: 'Sample Product (Dev Mode)',
    by: 'Test Artist'
  }
};
